import { PropTypes } from 'react-desc';
import { DSCheckbox } from '../Checkbox/DSCheckbox.js';
import { o as orientation } from '../prop-types-cc01d273.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '../Checkbox/elements/CheckMark.js';
import 'styled-components';
import '../Checkbox/defaultProps.js';
import '../Checkbox/props.js';

var props = {
  /**
   * Allows a function that is triggered once the checkbox group changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the checkbox group changes'),

  /**
   * Default active value
   */
  activeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).description('Default active value'),

  /**
   * Checkbox group items to show of type DSCheckbox
   */
  children: PropTypes.arrayOf(PropTypes.shape({
    type: DSCheckbox
  })).description('Checkbox group items to show of type DSCheckbox'),

  /**
   * Whether the checkbox group is disabled or not
   */
  disabled: PropTypes.bool.description('Whether the checkbox group is disabled or not'),

  /**
   * ['horizontal', 'vertical']
   */
  orientation: PropTypes.oneOf(orientation).description("['horizontal', 'vertical']"),

  /**
   * label props
   */
  labelProps: PropTypes.objectOf(PropTypes.shape({
    feedbackMessage: PropTypes.string,
    labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    required: PropTypes.bool
  })).description('label props')
};

export { props };
//# sourceMappingURL=props.js.map
